<div class="about-page">
  <app-navbar page="about"></app-navbar>

  <!-- Page Hero -->
  <section class="about-hero">
    <div class="about-hero-content">
      <h2 class="eyebrow centered">About Us</h2>
      <h1 class="about-hero-title">Strengthening Healthcare Systems</h1>
      <p class="about-hero-subtitle">
        e-Likita bridges healthcare delivery gaps by putting AI-powered clinical
        decision support directly into the hands of frontline workers — wherever
        they are, however limited the resources.
      </p>
    </div>
  </section>

  <!-- Mission -->
  <section class="about-mission">
    <div class="about-mission-visual">
      <div class="about-visual-frame">
        <div class="about-visual-decor-1"></div>
        <div class="about-visual-decor-2"></div>
        <img src="/assets/images/about-image.webp" alt="Doctor consultation" class="about-visual-img">
      </div>
    </div>

    <div class="about-mission-text">
      <h2 class="section-title">Our Mission</h2>
      <p class="section-body">
        Built to integrate seamlessly into existing healthcare systems, e-Likita
        strengthens frontline healthcare workers with intuitive digital tools and
        enables real-time collaboration with experts. We exist to close the
        distance between a patient in a remote clinic and the specialist guidance
        they deserve.
      </p>

      <div class="founder-quote">
        <img src="/assets/images/drsadiq.jpg" alt="Dr. Muhammad Saddiq" class="founder-avatar">
        <div>
          <p class="quote-text">
            "Our goal is to bridge gaps in healthcare delivery, making quality
            healthcare more accessible, efficient, and sustainable"
          </p>
          <p class="quote-author">Dr. Muhammad Saddiq</p>
          <p class="quote-role">Founder</p>
        </div>
      </div>
    </div>
  </section>

  <mat-divider></mat-divider>

  <!-- Values -->
  <section class="about-values">
    <div class="section-header">
      <h2 class="eyebrow centered">Why e-Likita</h2>
      <h3 class="section-title">What guides our work</h3>
    </div>

    <div class="values-grid">
      <div *ngFor="let value of values" class="value-item">
        <div class="value-icon-wrapper">
          <mat-icon class="value-icon">{{ value.icon }}</mat-icon>
        </div>
        <h3 class="value-title">{{ value.title }}</h3>
        <p class="value-description">{{ value.description }}</p>
      </div>
    </div>
  </section>

  <mat-divider></mat-divider>

  <!-- Partners -->
  <section class="about-partners">
    <div class="section-header">
      <h2 class="eyebrow centered">Collaborations</h2>
      <h3 class="section-title">Partners & Supporters</h3>
      <p class="section-subtitle">
        e-Likita was built through a collaboration between Dechi Health Trust Fund,
        Africa Health Care Development Trust, and DAALITech, with the support of
        dedicated Microsoft volunteers through the Microsoft Global Hackathon.
      </p>
    </div>

    <div class="partners-list">
      <div *ngFor="let partner of partners" class="partner-item" [class.partner-featured]="partner.featured">
        <div class="partner-icon-wrapper">
          <img [src]="partner.logo" [alt]="partner.name" class="partner-logo-img">
        </div>
        <a [href]="partner.url" target="_blank" rel="noopener" class="partner-name">{{ partner.name }}</a>
        <p class="partner-description">{{ partner.description }}</p>
      </div>
    </div>
  </section>

  <!-- CTA -->
  <section class="about-cta">
    <h2 class="cta-title">Want to bring e-Likita to your facility?</h2>
    <p class="cta-subtitle">We'd love to hear from you and explore how we can help.</p>
    <a routerLink="/contact" class="cta-btn">Get in Touch</a>
  </section>

  <app-footer></app-footer>
</div>